import * as StoreReview from 'expo-store-review';
import { Platform } from 'react-native';

/**
 * Checks if this is the first booking completion and requests a store review if so.
 */
export async function handleBookingCompletionReview() {
    if (Platform.OS === 'web') return;

    try {
        // Check if store review is available
        if (!(await StoreReview.isAvailableAsync())) {
            return;
        }
        // Request the review
        await StoreReview.requestReview();
    } catch (error) {
        console.error('Error handling booking completion review:', error);
    }
}
